"use client";

import { useState } from "react";
import { cn } from "./lib/utils";

export interface ExpandableTextProps {
	children: React.ReactNode;
	className?: string;
	maxLines?: 1 | 2 | 3;
	initiallyExpanded?: boolean;
}

export function ExpandableText({
	children,
	className,
	maxLines = 1,
	initiallyExpanded = false,
}: ExpandableTextProps): React.ReactElement {
	const [isExpanded, setIsExpanded] = useState(initiallyExpanded);

	const toggleExpand = (): void => {
		setIsExpanded(!isExpanded);
	};

	const commonClassNames = cn(
		"w-full text-left",
		{
			"line-clamp-1": maxLines === 1 && !isExpanded,
			"line-clamp-2": maxLines === 2 && !isExpanded,
			"line-clamp-3": maxLines === 3 && !isExpanded,
		},
		className,
	);

	if (isExpanded) {
		return (
			<div
				className={commonClassNames}
				onClick={toggleExpand}
				onKeyDown={(e) => {
					if (e.key === "Enter" || e.key === " ") {
						toggleExpand();
					}
				}}
			>
				{children}
			</div>
		);
	}

	return (
		<button
			type="button"
			className={cn(commonClassNames, "cursor-pointer outline-none")}
			onClick={toggleExpand}
		>
			{children}
		</button>
	);
}
